import type { ValidatedApiClient } from '../types/api-client';
import { type MapHeatmapQuery, mapHeatmapResponseSchema } from './schema';

export const createHeatmapApi = ({ validatedFetch }: ValidatedApiClient) => ({
    /**
     * Activity heatmap for a catalog title (density bins + k-means clusters per event category).
     * Example: `/v3/analytics/maps/43046/heatmap?event_types=kills,deaths&days=14`
     */
    get: (titleId: number | string, query: MapHeatmapQuery) => {
        const params = new URLSearchParams({
            event_types: query.eventTypes.join(','),
            days: String(query.days),
        });
        return validatedFetch(
            mapHeatmapResponseSchema,
            `/v3/analytics/maps/${encodeURIComponent(String(titleId))}/heatmap`,
            params,
        );
    },
});
